import { Outlet, NavLink } from 'react-router-dom';
import { UserButton } from '@clerk/clerk-react';

// Check if Clerk is enabled
const clerkEnabled = !!import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

export default function AdminLayout() {
    const navItems = [
        { path: '/admin', label: 'Dashboard', icon: '⚡' },
        { path: '/admin/content', label: 'Content', icon: '✏️' },
        { path: '/admin/leads', label: 'Leads', icon: '📥' },
    ];

    return (
        <div className="min-h-screen bg-void-light flex">
            {/* Sidebar */}
            <aside className="w-64 bg-void border-r border-white/10 flex flex-col">
                {/* Logo */}
                <div className="p-6 border-b border-white/10">
                    <h1 className="font-display text-xl text-neon-green font-bold tracking-tight">
                        CONTROL CENTER
                    </h1>
                    <p className="text-xs text-zinc-500 mt-1">Admin Dashboard</p>
                </div>

                {/* Navigation */}
                <nav className="flex-1 p-4">
                    <ul className="space-y-2">
                        {navItems.map((item) => (
                            <li key={item.path}>
                                <NavLink
                                    to={item.path}
                                    end={item.path === '/admin'}
                                    className={({ isActive }) =>
                                        `flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${isActive
                                            ? 'bg-neon-green/10 text-neon-green border border-neon-green/30'
                                            : 'text-zinc-400 hover:text-white hover:bg-white/5'
                                        }`
                                    }
                                >
                                    <span>{item.icon}</span>
                                    <span className="font-medium">{item.label}</span>
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>

                {/* User */}
                <div className="p-4 border-t border-white/10">
                    <div className="flex items-center gap-3">
                        {clerkEnabled ? (
                            <UserButton afterSignOutUrl="/" />
                        ) : (
                            <div className="w-8 h-8 rounded-full bg-neon-green/20 flex items-center justify-center text-neon-green text-sm font-bold">
                                A
                            </div>
                        )}
                        <span className="text-sm text-zinc-400">Admin</span>
                    </div>
                </div>
            </aside>

            {/* Main content */}
            <main className="flex-1 overflow-auto">
                <div className="p-8">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}
